import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const imageUrlLogo = process.env.PUBLIC_URL + '/images/rmt-logo.png';

const navLinks = [
  { to: '/how/works', label: 'How it works' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/faq', label: 'FAQ' },
  { to: '/blog', label: 'Blog' },
  { to: 'https://renewmytags.com', label: 'About', external: true },
];

const PublicHeader = ({ onSignInClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="tw-sticky tw-top-0 tw-z-50 tw-bg-white tw-border-b tw-border-gray-200 tw-shadow-sm">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-flex tw-items-center tw-justify-between tw-h-16 md:tw-h-20">
          {/* Logo */}
          <Link to="/" className="tw-flex-shrink-0">
            <img src={imageUrlLogo} alt="RMT" className="tw-h-10 md:tw-h-12" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="tw-hidden md:tw-flex tw-items-center tw-gap-1">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.to}
                  href={link.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-600 hover:tw-text-primary-600 tw-rounded-lg hover:tw-bg-gray-50 tw-transition-all tw-duration-200 tw-no-underline"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.to}
                  to={link.to}
                  className="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-600 hover:tw-text-primary-600 tw-rounded-lg hover:tw-bg-gray-50 tw-transition-all tw-duration-200 tw-no-underline"
                >
                  {link.label}
                </Link>
              )
            )}
          </nav>

          {/* Desktop Sign In */}
          <div className="tw-hidden md:tw-flex tw-items-center tw-gap-3">
            <button
              id="loginButtonTop"
              onClick={onSignInClick}
              className="tw-bg-primary-500 hover:tw-bg-primary-600 tw-text-white tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-border-0 tw-cursor-pointer tw-transition-all tw-duration-200 tw-shadow-sm hover:tw-shadow-md"
            >
              Sign In
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:tw-hidden tw-p-2 tw-rounded-lg hover:tw-bg-gray-100 tw-transition-colors tw-border-0 tw-bg-transparent tw-cursor-pointer"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <svg className="tw-w-6 tw-h-6 tw-text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="tw-w-6 tw-h-6 tw-text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:tw-hidden tw-border-t tw-border-gray-200 tw-bg-white">
          <div className="tw-px-4 tw-py-3 tw-space-y-1">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.to}
                  href={link.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-block tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-gray-600 hover:tw-text-primary-600 hover:tw-bg-gray-50 tw-rounded-lg tw-transition-colors tw-no-underline"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.to}
                  to={link.to}
                  className="tw-block tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-gray-600 hover:tw-text-primary-600 hover:tw-bg-gray-50 tw-rounded-lg tw-transition-colors tw-no-underline"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              )
            )}
            <div className="tw-pt-2 tw-px-4">
              <button
                id="loginButtonTopMobile"
                onClick={() => {
                  onSignInClick();
                  setMobileMenuOpen(false);
                }}
                className="tw-w-full tw-bg-primary-500 hover:tw-bg-primary-600 tw-text-white tw-px-5 tw-py-3 tw-rounded-lg tw-text-sm tw-font-semibold tw-border-0 tw-cursor-pointer tw-transition-all tw-duration-200"
              >
                Sign In
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default PublicHeader;
